import React from "react";
import MailingResources from "../../components/fullfillment/mailing-resources";

export const Resources = () => {
  return (
   <MailingResources status="New"/>
  );
};

export default Resources;